<template>
  <div>
    <BlockUI v-if="loading" message="Loading">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <v-card>
      <v-toolbar card>
        <v-text-field
            append-icon="search"
            label="ค้นหา"
            hide-details
            clearable
            v-model="pagination.searches.q"
        ></v-text-field>
        <v-spacer></v-spacer>
        <n-chip-date-picker
          custom-class="text-xs-center pt-3 pl-1 pr-2"
          v-model="pagination.searches.startDate"
          label="From"></n-chip-date-picker>
        <n-chip-date-picker
          custom-class="text-xs-center pt-3 pl-2 pr-1"
          v-model="pagination.searches.endDate"
          label="To"></n-chip-date-picker>
        <v-spacer></v-spacer>
          <v-select class="pt-1" hide-details
            v-model="pagination.searches.status"
            :items="[{value: null, text: 'ALL'}, {value: 'DRAFT', text: 'DRAFT'}, {value: 'COMPLETED', text: 'COMPLETED'}, {value: 'CANCELED', text: 'CANCELED'}]"
            label="Status"
          ></v-select>
        <v-spacer></v-spacer>
        <v-pagination
          :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)"
          v-model="pagination.page"
          @input="refresh"
          :total-visible="7"></v-pagination>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn fab dark small color="primary" to="/invoices/add" class="text-xs-center" slot="activator">
            <v-icon dark>playlist_add</v-icon>
          </v-btn>
          <span>Add Invoice</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :loading="loading"
          :headers="headers"
          :items="loadedItems"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          class="elevation-0"
        >
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
          <td class="text-xs-left" nowrap>{{ props.item.code }}</td>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.customer.name }}
          </td>
          <td class="text-xs-center">{{ props.item.bookDate | formatShortDate }}</td>
          <td class="text-xs-right">{{ props.item.totalPriceAmount | currency('',2) }}</td>
          <td class="text-xs-right">{{ props.item.totalVatAmount | currency('',2) }}</td>
          <td class="text-xs-right">{{ props.item.totalAmount | currency('',2) }}</td>
          <td class="text-xs-center">
            <v-chip small outline :color="$options.filters.statusBgColor(props.item.status)">{{ props.item.status }}</v-chip>
          </td>
          <td class="text-xs-center">
            <v-layout>
              <v-tooltip left>
                <v-btn icon class="mx-0" slot="activator" :href="printoutUrl(props.item.id)" target="_blank">
                  <v-icon small color="red">mdi-adobe-acrobat</v-icon>
                </v-btn>
                <span>Download</span>
              </v-tooltip>
              <v-tooltip left>
                <v-btn icon class="mx-0" slot="activator" @click="print(props.item.id)">
                  <v-icon small color="blue">print</v-icon>
                </v-btn>
                <span>Print</span>
              </v-tooltip>
              <v-tooltip left>
                <v-btn icon class="mx-0" slot="activator" :to="`/invoices/${props.item.id}`">
                  <v-icon small color="teal">zoom_in</v-icon>
                </v-btn>
                <span>แก้ไข {{props.item.code}}</span>
              </v-tooltip>
              <v-tooltip left>
                <v-btn icon class="mx-0" slot="activator" @click="deleteItem(props.item)" :disabled="props.item.status === 'COMPLETED'">
                  <v-icon small color="pink">delete</v-icon>
                </v-btn>
                <span>ลบ {{props.item.code}}</span>
              </v-tooltip>
            </v-layout>
          </td>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          From {{ pageStart }} to {{ pageStop }} of {{ pagination.totalItems }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import _ from 'lodash'
import swal from 'sweetalert2'
import moment from 'moment'
import NChipDatePicker from '@/components/date-picker/NChipDatePicker'

export default {
  name: 'Invoice',
  components: {
    NChipDatePicker
   },
  data() {
    return {
      loading: false,
      loadedItems: []
    }
  },
  computed: {
    ...mapState('invoice', [ 'list', 'headers' ]),
    ...mapGetters(['token']),
    pagination: {
      get() {
        return this.list
      },
      set(pagination) {
        this.$store.commit('invoice/SET_LIST', pagination)
      }
    }
  },
  methods: {
    ...mapActions('invoice', ['loadItems', 'remove']),
    printoutUrl (id) {
      return this.$store.getters['invoice/printoutUrl'](id)
    },
    print (id) {
      this.$store.dispatch('printPdf', this.printoutUrl(id))
    },
    onClearDateSelected() {
      this.pagination.startDate = ''
      this.pagination.endDate = ''
      this.reload(this)
      this.$refs.dateSelected.dateRange = {start: '', end: ''}
    },
    onDateSelected(daterange) {
      this.pagination.startDate = moment(daterange.start).format('YYYY-MM-DD')
      this.pagination.endDate = moment(daterange.end).format('YYYY-MM-DD')
      this.reload(this)
    },
    deleteItem(item) {
      swal({
        title: 'Delete Invoice',
        text: 'Please, confirm your action.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Confirm'
      }).then(result => {
        if (result.value) {
          this.loading = true
          this.remove(item)
          .then(response => {
            this.loading = false
            this.reload(this)
            this.$snotify.success('Delete Invoice.', 'Success!')
          }).catch(error => {
            this.loading = false
            this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'Fail!')
          })
        }
      })
    },
    refresh() {
      this.reload(this)
    },
    reload: _.debounce((self) => {
      self.loading = true
      self.loadItems(self.pagination)
      .then((response) => {
        self.pagination.totalItems = response.data.totalItems
        self.loadedItems = response.data.items
        self.loading = false
      }).catch((error)=>{
        self.loading = false
        swal('Error!', error.message, 'error')
      })
    }, 1000)
  },
  mounted () {
    this.reload(this)
  },
  watch: {
    'pagination.searches': {
      handler() {
        this.reload(this)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invoices/list.vue